export default () => {

  const $html = $('html'),
        $menuOpen = $('.js-menu-open'),
        $menuClose = $('.js-menu-close'),
        $menu = $('#hamburger-menu')
  ;

  $menuOpen.on('click', () => {
    $html.attr('data-menu', 'open');
    $menu.attr('aria-hidden', 'false');
  });

  $menuClose.on('click', closeMenu);

  $(document).on('keydown', ({ key }) => {
    if (key === 'Esc' || key === 'Escape') {
      closeMenu();
    }
  });

  function closeMenu() {
    $html.attr('data-menu', 'closed');
    $menu.attr('aria-hidden', 'true');
  }

};
